import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BFF_URL } from '../environments/environment';
import { take } from 'rxjs';
import { GROUP_NUMBERS_RES } from '../interfaces/group-number';

@Injectable({
	providedIn: 'root'
})
export class GroupNumberService {
	private http = inject(HttpClient);

	serviceUrl = `${BFF_URL}/v1/ca/number-groups`;

	getGroupNumbers(province?: string): Promise<GROUP_NUMBERS_RES> {
		const url = province ? `${this.serviceUrl}?province=${province}` : this.serviceUrl;
		return new Promise<GROUP_NUMBERS_RES>((resolve, reject) => {
			this.http.get<GROUP_NUMBERS_RES>(url)
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
	getProvinces(): Promise<any> {
		const url = `${BFF_URL}/v1/ca/provinces`;
		return new Promise<any>((resolve, reject) => {
			this.http.get<any>(url)
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
}
